<template>
  <div class="pie-chart">
    <div class="pie-chart__chart mb-16">
      <canvas
        class="pie-chart__canvas"
        ref="chart" />
    </div>

    <div class="pie-chart__actions">
      <a
        href="#"
        ref="downloadImageLink"
        class="btn btn--secondary btn--xs"
        @click.prevent="downloadImage">Download image</a>
    </div>
  </div>
</template>

<script>
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
} from 'chart.js';
import 'chartjs-adapter-date-fns';

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
);

Chart.defaults.font.size = 14;
Chart.defaults.font.family = "Muli";

import { mapGetters } from "vuex";
import downloadChartImage from "./download-image";

export default {
  data() {
    return {
      chart: null
    }
  },
  computed: {
    ...mapGetters("chart", ["title", "xAxisTitle", "yAxisTitle", "type", "stacked", "seriesColumns", "series", "fields", "result", "labels", "datasets", "datasetUpdatedAt", "xAxis", "xAxisType", "fieldTypes", "legendPosition", "optionsPlugins"]),
    data() {
      const dataset = {
        data: [],
        backgroundColor: []
      };

      this.datasets.forEach(d => {
        dataset.data.push(d.data);
        dataset.backgroundColor.push(d.backgroundColor);
      });

      return {
        labels: this.datasets.map(d => d.label),
        datasets: [dataset]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: this.optionsPlugins,
        elements: {
          arc: {
            borderWidth: 0
          }
        }
      }
    },
    chartConfig() {
      return {
        type: "pie",
        data: this.data,
        options: this.chartOptions
      };
    }
  },
  watch: {
    result() {
      this.$nextTick(() => {
        this.updateChart();
      });
    },
    datasetUpdatedAt() {
      this.$nextTick(() => {
        this.updateChart();
      });
    }
  },
  methods: {
    updateChart() {
      if(this.chart) {
        this.chart.data = this.data;
        this.chart.options = this.chartOptions;

        this.chart.update();
      } else {
        const context = this.$refs.chart.getContext("2d");

        this.chart = new Chart(context, this.chartConfig);
      }
    },
    downloadImage() {
      downloadChartImage(this.chart);
    }
  },
  mounted() {
    this.updateChart();
  }
};
</script>

<style lang="scss">
.pie-chart {
  &__chart {
    width: 100%;
    position: relative;
  }

  &__canvas {
    width: 100%;
    height: 420px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
